<template>
  <div class="ques">
    <div class="ques-title">{{detail.title}}</div>
    <div class="ques-cont">{{detail.content[0]}}</div>
    <div class="foot">
      <Button
          style="width: 5rem;"
          round
          size="normal"
          type="warning"
          block
          @click="prev"
      >返回</Button>
    </div>

  </div>
</template>

<script>
import { Button } from "vant";

export default {
  name: "ques.vue",
  props: ["acid"],
  data() {
    return {
      detail: {}
    };
  },
  components: {
    Button
  },
  mounted() {
    this.$nextTick(() => {
      this.getQuestions();
    });
  },
  methods: {
    getQuestions() {
      this.$api.answer
          .questions({aid:this.acid})
          .then((res) => {
            if (res.status * 1 === 200) {
              this.detail = res.data.questions[0]||[]
            }
          });
    },
    prev() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .ques{
    background: #D22E2C url("https://oss.mcloud.moveclub.cn/mpms/20210719/1626693893-60f561057549f.png") no-repeat;
    width: 100%;
    height: 100vh;
    background-size: 100%;
    position: relative;
    .ques-title{
      font-size: .34rem;
      color: #FFFFFF;
      letter-spacing: .0214rem;
      font-weight: bold;
      position: absolute;
      left: 1.39rem;
      top: 5.21rem;
      width: 2.73rem;
      height: .96rem;
      line-height: .48rem;
    }
    .ques-cont{
      font-size: .28rem;
      color: rgba(255,255,255,0.85);
      letter-spacing: 0;
      position: absolute;
      left: 1.39rem;
      top: 7.58rem;
      width: 4.81rem;
      height: 3.8rem;
      overflow-y: scroll;
    }
    .foot{
      position: absolute;
      bottom: .5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
</style>
